import { hubBody, hubRequest } from "./client";
export type OpenScope = "data:read" | "home:write" | "app:publish" | "tasks:write" | "decisions:submit" | "approvals:start" | "posts:write" | "views:write";
export type DataToolDescriptor = {
  name: string;
  title: string;
  description: string;
  inputSchema: Record<string, unknown>;
  outputSchema: Record<string, unknown>;
  sensitivity: "L0" | "L1" | "L2";
  requiredScopes: OpenScope[];
  readOnly: boolean;
};
export type DataToolResult<T = unknown> = {
  tool: string;
  asOf: string;
  data: T;
  links: { label: string; href: string }[];
  pagination?: { nextCursor: string | null; hasMore: boolean; total?: number };
};
export type DataCatalog = {
  tools: DataToolDescriptor[];
  limits: { maxResultBytes: number };
  downloads: { guide: string; template: string };
};
/** Browser, MCP and sandbox hosts share the server's canonical tools; this path uses current login. */
export const listDataTools = () => hubRequest<DataCatalog>("/open/catalog");
export const callDataTool = <T = unknown>(
  name: string,
  args: Record<string, unknown> = {},
) =>
  hubRequest<DataToolResult<T>>(
    `/open/tools/${encodeURIComponent(name)}`,
    hubBody(args),
  );
export const listDataAudit = (query: Record<string, string> = {}) =>
  hubRequest<{ items: Record<string, unknown>[] }>("/open/audit", {}, query);

export type CompanyRules = {
  version: number;
  content: string;
  authorId: string | null;
  versions: { version: number; authorId: string | null; createdAt: number; rollbackOf: number | null }[];
};
export const getCompanyRules = () => hubRequest<CompanyRules>("/company-rules");
export const updateCompanyRules = (version: number, content: string) =>
  hubRequest<CompanyRules>("/company-rules", hubBody({ version, content }, "PUT"));
export const rollbackCompanyRules = (version: number, rollbackVersion: number) =>
  hubRequest<CompanyRules>("/company-rules/rollback", hubBody({ version, rollbackVersion }));
